import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mySchedSet: {
    settingNo: null,
    mberNo: null,
    screenMode: 0,
    mobileScreenMode: null,
    personalYn: true,
    companyYnList: [],
    groupYnList: [],
    viewMode: "D",
    excludeUnrelated: "Y",
  },
  isDarkMode: null,
};

const scheduler = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    getSetting(state, action) {
      state.mySchedSet = {
        ...action.payload,
        excludeUnrelated: action.payload.excludeUnrelated ? "Y" : "N",
      };
      state.isDarkMode = action.payload.screenMode ? "dark" : "";
    },
    resetSetting(state) {
      state.mySchedSet = {};
    },
  },
});

export const { getSetting, resetSetting } = scheduler.actions;
export default scheduler;
